// Configuration for CustomEventPopup component
export const createCustomEventPopupConfig = ({
    // Core popup state
    isOpen,
    setOpen,
    isEdit,
    isManualSaving,
    saveEvent,
    onClose,
    anchor,
    
    // Event data
    popupEventTitle,
    popupEventDescription,
    popupEventAllDay,
    popupEventDate,
    selectedColor,
    availability,
    showAvailabilitySelect,
    isX,
    isEditable,
    isChecked,
    
    // Event handlers
    titleChange,
    descriptionChange,
    allDayChange,
    changeStartDate,
    changeEndDate,
    handleAvailabilityChange,
    handleEventX,
    handleEventInvoiced,
    handleResourceCheckInEvent,
    changeColor,
    
    // UI configuration
    headerText,
    popupButtons,
    responsivePopup,
    closeOnOverlayClick = true,
    fullScreen = true,
    
    // Resources and references
    items,
    startRef,
    endRef,
    onDelete
}) => ({
    // Core props
    isOpen,
    setOpen,
    isEdit,
    isManualSaving,
    saveEvent,
    onClose,
    fullScreen,
    headerText,
    anchor,
    closeOnOverlayClick,
    
    // Event data
    popupEventTitle,
    popupEventDescription,
    popupEventAllDay,
    popupEventDate,
    selectedColor,
    availability,
    showAvailabilitySelect,
    isX,
    isEditable,
    isChecked,
    
    // Event handlers
    titleChange,
    descriptionChange,
    allDayChange,
    changeStartDate,
    changeEndDate,
    onAvailabilityChange: handleAvailabilityChange,
    onHandleEventXChange: handleEventX,
    onHandleEventInvoicedChange: handleEventInvoiced,
    handleResourceCheckInEvent,
    changeColor,
    
    // UI configuration
    popupButtons,
    responsivePopup,
    
    // Resources and references
    items,
    startRef,
    endRef,
    onDelete
});

// Default configuration values
export const defaultCustomEventPopupConfig = {
    fullScreen: true,
    closeOnOverlayClick: true
};
